// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.uploadIdContainer.errorComponent.';

const TRY_AGAIN = `${DOMAIN}tryAgainButton`;

export { TRY_AGAIN };
